import { ExportDestination, ExportFileFormats, ExportSource } from "../main/constants/export.constants";

export default class Tag {

    constructor(Rest) {
        this.rest = Rest.rest;
    }

    all(page, pagination, includes) {
        page = page || 1;
        pagination = (pagination != null) ? pagination : false;

        const params = {
            page,
            pagination,
        }

        if (includes) {
            params['includes[]'] = includes;
        }

        return this.rest.one('tag').get(params);
    };

    fetchAllNew(page, per_page, search, pagination) {
        page = page || 1;
        per_page = per_page || 20;
        search = search || '';
        pagination = (pagination != null) ? pagination : false;
        return this.rest.one('tag').get({ page, per_page, search, pagination });
    };

    searchTags(search, page, withShared) {
        return this.rest.one('tag').get({ search: search, with_shared: withShared, page: page || 1, per_page: 15, pagination: true, 'includes[]': ['count_subscribers'] });
    };

    find(id) {
        return this.rest.one('tag', id).get({ 'includes[]': ['full_data', 'count_active_subscribers', 'automails', 'segments', 'subscriber_forms'] });
    };

    store(name) {
        return this.rest.all('tag').post({ name: name });
    };

    findByName(name, withShared) {
        var findShared = withShared == null ? true : withShared;
        return this.rest.one('tag').get({ search: name, with_shared: findShared, page: 1, pagination: false });
    };

    update(tag) {
        return this.rest.all('tag/' + tag.id).customPUT(tag);
    };

    delete(id) {
        return this.rest.one('tag', id).remove();
    };

    exportProgress(id) {
        return this.rest.one('tag', id).one('export-progress').get();
    };

    getExportById(id) {
        return this.rest.one('export', id).get();
    }

    getExportDownloadLink(id) {
        return this.rest.one('export', id).one('download').get();
    }

    search(search, page, view, attributes, orderBy) {
        return this.rest.one('tag', attributes.tagId).one('subscribers').get({
            search: search,
            page: page || 1,
            view: view || 'cards',
            order_column: orderBy || 'id'
        });
    };

    subscribers(attributes, page, view, orderBy) {
        return this.rest.one('tag', attributes.tagId).one('subscribers').get({
            page: page || 1,
            view: view || 'card',
            order_column: orderBy || 'id'
        });
    };

    subscribersPaginated(tagId, page) {
        return this.rest.one('tag', tagId).one('getPage').get({ page: page });
    };

    segments(id) {
        return this.rest.one('tag', id).one('segments').get();
    };

    subscriberCount(id) {
        return this.rest.one('tag', id).get({ count_subscribers: true });
    };

    exportToFile(exportData) {
        return this.rest.all('export').post({
            source: ExportSource.Tag,
            destination: ExportDestination.File,
            tag: {
                id: exportData.tagId
            },
            export: {
                file_format: ExportFileFormats.Xls,
                export_active: exportData.exportActive,
                export_suppressed: exportData.exportSuppressed,
                custom_fields: exportData.fields.map(({ id }) => id).filter(Boolean)
            },
        });
    };

    exportToTag(exportData) {
        return this.rest.all('export').post({
            source: ExportSource.Tag,
            destination: ExportDestination.Tag,
            tag: {
                id: exportData.tagId
            },
            export: {
                tags: exportData.toTagsIds,
                export_active: exportData.exportActive,
                export_suppressed: exportData.exportSuppressed,
                custom_fields: exportData.fields.map(({ id }) => id).filter(Boolean)
            },
        })
    };
};

Tag.$inject = ['Rest'];
